import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../../services/apiService";

const NewRadioFile = () => {
  const navigate = useNavigate();

  const [content, setContent] = useState({
    file_path: null,
    channel_id: "",
    audio_url: "", // Added state for audio_url
    duration: "", 

  });

  const [audioPreview, setAudioPreview] = useState(null);
  const [channels, setChannels] = useState([]);
  const [audioOption, setAudioOption] = useState("file"); // State to track selected audio option

  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const response = await apiService.fetchData("admin/channels");
        setChannels(response.data);
      } catch (error) {
        console.error("Error fetching channels:", error);
      }
    };

    fetchChannels();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file_path") {
      const file = files[0];
      setContent({ ...content, file_path: file });
      setAudioPreview(URL.createObjectURL(file)); 
    } else {
      setContent({ ...content, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append("channel", content.channel_id); // Channel id
    formData.append("duration", content.duration);

    // Append audio file or URL based on the selected option
    if (audioOption === "file" && content.file_path) {
      formData.append("files", content.file_path);
    }
    if (audioOption === "url" && content.audio_url) {
      formData.append("audio_url", content.audio_url);
    }

    try {
      const response = await apiService.postData("admin/radio-file-path", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Upload successful:", response);
      navigate("/radio/file"); // Navigate after success
    } catch (error) {
      console.error("Error uploading content:", error);
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>New Radio</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Channel</label>
                <select
                  className="form-control"
                  name="channel_id"
                  value={content.channel_id}
                  onChange={handleChange}
                >
                  <option value="">Select Channel</option>
                  {channels.map((channel) => (
                    <option key={channel.channel_id} value={channel.channel_id}>
                      {channel.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Radio Buttons for Audio Option */}
              {/* <div className="form-group mt-3">
                <label>Audio Option</label>
                <div>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="audio_option"
                      value="file"
                      checked={audioOption === "file"}
                      onChange={() => setAudioOption("file")}
                    /> Audio File
                  </label>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="audio_option"
                      value="url"
                      checked={audioOption === "url"}
                      onChange={() => setAudioOption("url")}
                    /> Audio URL
                  </label>
                </div>
              </div> */}

              {/* Audio File Input (shown if 'file' is selected) */}
              {audioOption === "file" && (
                <div className="form-group mt-3">
                  <label>Audio File</label>
                  <input
                    type="file"
                    name="file_path"
                    className="form-control"
                    accept="audio/*"
                    onChange={handleChange}
                  />

                  {audioPreview && (
                    <audio controls className="mt-2 w-100">
                      <source src={audioPreview} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                  )}
                </div>
              )}

              {/* Audio URL Input (shown if 'url' is selected) */}
              {audioOption === "url" && (
                <div className="form-group mt-3">
                  <label htmlFor="audio-url" className="form-label">
                    Enter Audio URL
                  </label>
                  <div className="input-group">
                    <span
                      className="input-group-text"
                      id="audio-addon"
                      style={{ color: "#6c757d", backgroundColor: "#e9ecef" }}
                    >
https://playzippy.s3.amazonaws.com/7777/                    </span>
                    <input
                      type="text"
                      name="audio_url"
                      className="form-control"
                      id="audio-url"
                      value={content.audio_url}
                      onChange={handleChange}
                      placeholder="Enter file name or path"
                      aria-describedby="audio-addon"
                    />
                  </div>
                </div>
              )}
<div className="form-group mt-3">
  <label>Duration in seconds</label>
  <input
    type="number"
    name="duration"
    className="form-control"
    value={content.duration}
    onChange={handleChange}
    placeholder="Enter duration"
    min="0"
  />
</div>

              <div className="d-flex gap-2 mt-4">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Add Radio
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/radio/file")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRadioFile;
